<template>
  <div>
    <loading v-if="isLoading" />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card class="permission-card" v-if="!save_status">
        <v-toolbar color="#006699" dark flat>
          <v-toolbar-title>
            <v-icon left>mdi-shield-account</v-icon>
            Alterar Permissão
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="fecharComponente">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-container>
            <v-form ref="form" v-model="formValid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field 
                    v-model="usuario.nomeUsuario" 
                    label="Nome" 
                    outlined
                    dense
                    disabled
                    prepend-inner-icon="mdi-account"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field 
                    v-model="usuario.Usuario_username" 
                    label="Email" 
                    outlined
                    dense
                    disabled
                    prepend-inner-icon="mdi-email"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-select
                    :items="getRolesForCurrentUser"
                    v-model="editedItem.autorizacoes_nome"
                    :rules="obrigatorioRules"
                    label="Nível de Acesso"
                    :disabled="disabilitaRole"
                    outlined
                    dense
                    prepend-inner-icon="mdi-account-key"
                    item-text="text"
                    item-value="value"
                    :menu-props="{ maxHeight: '200' }"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                        <v-list-item-subtitle v-if="item.description" class="caption">
                          {{ item.description }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn 
            color="red darken-1" 
            dark 
            small
            @click="fecharComponente"
            class="mr-2"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="#006699" 
            depressed
            
            dark
            small
            :disabled="!formValid || isLoading"
            :loading="isLoading"
            @click="save"
          >
            <v-icon color="white" left>mdi-content-save</v-icon>
            Salvar Alterações
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "../../../../plugins/axios";
import Swal from "sweetalert2";
const ls = require("local-storage");
import loading from "../../../../components/loading.vue";

export default {
  props: ["usuario"],
  components: {
    loading
  },

  data: () => ({
    disabilitaRole: false,
    formValid: true,
    isLoading: false,
    save_status: false,
    dialog: true,
    obrigatorioRules: [(value) => !!value || "Selecione um nível de acesso"],
    
    // Estrutura melhorada para os roles
    roleDefinitions: {
      ROLE_FUNC: [
        { value: "ROLE_FUNC", text: "Funcionário", description: "Acesso básico ao sistema" },
        { value: "ROLE_EST", text: "Estudante", description: "Acesso apenas para estudantes" },
        { value: "ROLE_PROF", text: "Professor", description: "Acesso para docentes" }
      ],
      ROLE_PED: [
        { value: "ROLE_PED", text: "Pedagogo", description: "Acesso completo à área pedagógica" },
        { value: "ROLE_COOR", text: "Coordenador", description: "Acesso de coordenação pedagógica" },
        { value: "ROLE_FUNC", text: "Funcionário", description: "Acesso básico ao sistema" },
        { value: "ROLE_EST", text: "Estudante", description: "Acesso apenas para estudantes" },
        { value: "ROLE_PROF", text: "Professor", description: "Acesso para docentes" }
      ],
      ROLE_DIR: [
        { value: "ROLE_PED", text: "Pedagogo", description: "Acesso completo à área pedagógica" },
        { value: "ROLE_COOR", text: "Coordenador", description: "Acesso de coordenação pedagógica" },
        { value: "ROLE_FUNC", text: "Funcionário", description: "Acesso básico ao sistema" },
        { value: "ROLE_EST", text: "Estudante", description: "Acesso apenas para estudantes" },
        { value: "ROLE_PROF", text: "Professor", description: "Acesso para docentes" },
        { value: "ROLE_PWR", text: "Power User", description: "Acesso ampliado a configurações" }
      ],
      ROLE_PWR: [
        { value: "ROLE_PED", text: "Pedagogo", description: "Acesso completo à área pedagógica" },
        { value: "ROLE_COOR", text: "Coordenador", description: "Acesso de coordenação pedagógica" },
        { value: "ROLE_FUNC", text: "Funcionário", description: "Acesso básico ao sistema" },
        { value: "ROLE_EST", text: "Estudante", description: "Acesso apenas para estudantes" },
        { value: "ROLE_PROF", text: "Professor", description: "Acesso para docentes" },
        { value: "ROLE_PWR", text: "Power User", description: "Acesso ampliado a configurações" }
      ],
      ROLE_ADM: [
        { value: "ROLE_PED", text: "Pedagogo", description: "Acesso completo à área pedagógica" },
        { value: "ROLE_COOR", text: "Coordenador", description: "Acesso de coordenação pedagógica" },
        { value: "ROLE_SEC", text: "Secretário", description: "Acesso à área administrativa" },
        { value: "ROLE_FUNC", text: "Funcionário", description: "Acesso básico ao sistema" },
        { value: "ROLE_EST", text: "Estudante", description: "Acesso apenas para estudantes" },
        { value: "ROLE_PROF", text: "Professor", description: "Acesso para docentes" },
        { value: "ROLE_PWR", text: "Power User", description: "Acesso ampliado a configurações" },
        { value: "ROLE_ADM", text: "Administrador", description: "Acesso total ao sistema" }
      ]
    },
    
    editedItem: {
      idFuncionario: "",
      idPessoa: "",
      email: "",
      nomeUsuario: "",
      autorizacoes_nome: "",
      enable: false,
      idusuario_autorizacao: "",
      newpassword: "",
      professor: 0,
      pkUsuario: 0,
      passwordnew: ""
    },
    defaultItem: {
      idFuncionario: "",
      idPessoa: "",
      email: "",
      nomeUsuario: "",
      autorizacoes_nome: "",
      enable: false,
      idusuario_autorizacao: "",
      newpassword: "",
      professor: 0
    }
  }),

  computed: {
    Instituicao() {
      return ls.get("i_id");
    },
    role() {
      return ls.get("role");
    },
    getRolesForCurrentUser() {
      return this.roleDefinitions[this.role] || [];
    }
  },

  created() {
    this.editedItem = Object.assign({}, this.usuario);
    this.disabilitaRole = this.usuario.autorizacoes_nome === "ROLE_EST";
  },

  methods: {
    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        
        try {
          const params = {
            idusuario_autorizacao: this.editedItem.idusuario_autorizacao,
            autorizacoes_nome: this.editedItem.autorizacoes_nome,
          };

          const response = await axios.post("/mudarPermissaoByUser", params);
          
          if (response.data && response.data.affectedRows) {
            Swal.fire({
              title: 'Sucesso',
              text: 'Permissão alterada com sucesso!',
              icon: 'success',
              timer: 2000,
              showConfirmButton: false
            });
            this.fecharComponente();
          }
        } catch (error) {
          Swal.fire({
            title: 'Erro',
            text: 'Ocorreu um erro ao alterar a permissão',
            icon: 'error',
            confirmButtonText: 'Fechar'
          });
        } finally {
          this.isLoading = false;
        }
      }
    },
    
    fecharComponente() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.$emit("fecharComponente", false);
    },
  },
};
</script>

<style scoped>
.permission-card {
  border-radius: 8px;
}

.dialog-actions {
  padding: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

/* Melhoria na seleção de roles */
.v-select >>> .v-select__selection--comma {
  font-weight: 500;
  color: var(--v-primary-base);
}

/* Efeitos de transição */
.v-input {
  transition: all 0.3s ease;
}

/* Responsividade */
@media (max-width: 600px) {
  .permission-card {
    margin: 0;
    border-radius: 0;
  }
  
  .v-card__text {
    padding: 16px;
  }
}

/* Estilo para os itens da lista de seleção */
.v-list-item__title {
  font-weight: 500;
}

.v-list-item__subtitle {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.75rem;
}
</style>